import "../scss/styles.scss";
import PageDefault from "./pages/PageDefault.js";
import PageSei from "./pages/PageSei.js";
import PageGoth from "./pages/PageGoth.js";
import PageManager from "./pages/PageManager.js";

export default class FactoryManager {

	static factory(cls, ...rest) {
		return new FactoryManager.classes[cls](rest[0]);
	}

}

FactoryManager.classes = { PageDefault, PageSei, PageGoth, PageManager };